import { useMutation } from '@apollo/react-hooks';
import { kmsClient } from 'api';
import { CCA_START_GENERATE_CREATIVES_MUTATION } from './ccaStartGenerateCreatives.mutation';
import {
  CcaStartGenerateCreativesMutation,
  CcaStartGenerateCreativesMutationVariables
} from './__generated__/CcaStartGenerateCreativesMutation';

export const useCcaStartGenerateCreatives = () => {
  return useMutation<CcaStartGenerateCreativesMutation, CcaStartGenerateCreativesMutationVariables>(
    CCA_START_GENERATE_CREATIVES_MUTATION,
    { client: kmsClient }
  );
};
